const type = 'SET_CUSTOMER_PROTOCOL';

const setCustomerProtocol = (data) => ({
  type,
  data,
});

export { type };
export default setCustomerProtocol;
